import * as THEOplayerRuntime from "theoplayer";
import * as THEOplayerLegacyRuntime from "theoplayer-legacy";

import { getUseTHEOplayerV2FromLocalStorage } from "../enableTheoPlayerV2";
import { isNewVideoPlayerImportEnabled } from "../theoPlayer/newVideoPlayerImportFlag";

/*
  THEOplayerLegacyRuntimeの型ファイルには `export declare namespace videojs` の定義がある。
  ただし、module exportとしては扱われないため、importした型では`videojs`を直接参照できない。
  そのため、THEOplayerRuntimeとTHEOplayerLegacyRuntimeの両方で`videojs`が存在する前提を満たすために、独自の型を定義している。
*/
type TheoPlayerRuntime = typeof THEOplayerRuntime & {
  videojs: typeof THEOplayerRuntime.videojs;
};

export type TheoPlayerImportSource = "node-module" | "cdn-window";

export const getTheoPlayerImportSource = (): TheoPlayerImportSource => {
  return isNewVideoPlayerImportEnabled() ? "node-module" : "cdn-window";
};

export const getTHEOplayerRuntime = (): TheoPlayerRuntime => {
  const runtime = THEOplayerRuntime as TheoPlayerRuntime;
  const legacyRuntime = THEOplayerLegacyRuntime as unknown as TheoPlayerRuntime;

  const shouldUseLegacyRuntime = getUseTHEOplayerV2FromLocalStorage();

  // getUseTHEOplayerV2FromLocalStorageの値がtrueの場合はlegacyランタイムを優先して返す
  if (shouldUseLegacyRuntime) {
    if (legacyRuntime.videojs) {
      return legacyRuntime;
    }
  }

  if (runtime.videojs) {
    return runtime;
  }

  if (legacyRuntime.videojs) {
    console.warn(
      "THEOplayer v8ランタイム取得に失敗したため、legacyランタイムにフォールバックします"
    );
    return legacyRuntime;
  }

  console.error("THEOplayer runtimeを取得できません");
  throw new Error("THEOplayer runtimeがロードされていません");
};

export const getTHEOplayerRuntimeWithLibraryLocation = (): {
  THEOplayer: TheoPlayerRuntime;
  libraryLocation: string;
} => {
  const runtime = THEOplayerRuntime;
  const legacyRuntime = THEOplayerLegacyRuntime as unknown as TheoPlayerRuntime;
  const shouldUseLegacyRuntime = getUseTHEOplayerV2FromLocalStorage();

  if (shouldUseLegacyRuntime && legacyRuntime.videojs) {
    return {
      THEOplayer: legacyRuntime,
      libraryLocation: "/vendor/theoplayer-legacy/",
    };
  }

  if (runtime.videojs) {
    return {
      THEOplayer: runtime,
      libraryLocation: "/vendor/theoplayer/",
    };
  }

  if (legacyRuntime.videojs) {
    console.warn(
      "THEOplayer v8ランタイム取得に失敗したため、legacyランタイムにフォールバックします"
    );
    return {
      THEOplayer: legacyRuntime,
      libraryLocation: "/vendor/theoplayer-legacy/",
    };
  }

  console.error("THEOplayer runtimeを取得できません");
  throw new Error("THEOplayer runtimeがロードされていません");
};
